'use strict';
import React from 'react';
import ReactDOM from 'react-dom';
import {stringAsCharPattern} from './helpers.js';

class MenuLibrary extends React.Component {
  constructor() {
    super();
    this.state = {
      selected: 'none',
      filters: []
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.routerLocation !== this.props.routerLocation) return true;
    if (nextState.selected !== this.state.selected) return true;
    if (nextState.filters !== this.state.filters) return true;
    return false;
  }

  optionClicked(e) {
    this.setState({selected: e.target.getAttribute('data-option')});
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters) this.applyFilters();
  }

  addFilter(e) {
    this.setState({
      filters: [
        {
          name: e.target.getAttribute('data-filter'),
          title: e.target.getAttribute('data-filter-title')
        }
      ]
    });
  }

  clearFilters(filter) {
    this.setState({filters: []});
  }

  applyFilters() {
    let amountShown = 0;
    this.forEachDocument((thisDocument) => {
      for (let filter of this.state.filters) {
        if (!thisDocument.classList.contains(filter.name)) {
          thisDocument.classList.add('hidden');
        } else {
          thisDocument.classList.remove('hidden');
          amountShown += 1;
        }
      }
    });
    document.querySelector('.search-results').innerHTML = `Showing ${amountShown} documents filtered by ${this.state.filters[0].title}. <span class="link" onclick="showAllDocuments()">Show all documents</span>.`;
  }

  textSearch(e) {
    e.preventDefault();
    let searchTextRaw = document.querySelector('input[name="text-search"]').value;
    document.querySelector('input[name="text-search"]').value = '';
    let searchText = searchTextRaw.toLowerCase();
    let amountShown = 0;

    this.forEachDocument((thisDocument) => {
      let link = thisDocument.parentElement;
      let hide = false;
      if (link.getAttribute('data-title').toLowerCase().indexOf(searchText) === -1 &&
          link.getAttribute('data-author').toLowerCase().indexOf(searchText) === -1 &&
          link.getAttribute('data-year').toLowerCase().indexOf(searchText) === -1 &&
          link.getAttribute('data-tags').toLowerCase().indexOf(searchText) === -1) {
        hide = true;
      }
      if (hide) {
        thisDocument.classList.add('hidden');
      } else {
        thisDocument.classList.remove('hidden');
        amountShown += 1;
      }
    });
    document.querySelector('.search-results').innerHTML = `Showing ${amountShown} results for search “${searchTextRaw}”. <span class="link" onclick="showAllDocuments()">Show all documents</span>.`;
  }

  forEachDocument(callback) {
    let documents = document.querySelectorAll('.library-list article');
    for (let d = 0; d < documents.length; d += 1) {
      callback(documents[d]);
    }
  }

  getYearsList() {
    let yearsAggregated = {};
    this.forEachDocument((doc) => {
      let docYear = doc.parentElement.getAttribute('data-year');
      if (yearsAggregated.hasOwnProperty(docYear)) yearsAggregated[docYear] += 1;
      else yearsAggregated[docYear] = 1;
    });

    let yearsAggregatedArray = []
    for (let year in yearsAggregated) {
      yearsAggregatedArray.push({name: year, amount: yearsAggregated[year]});
    }

    yearsAggregatedArray.sort(function(a, b) {
      return parseInt(a.name) > parseInt(b.name)
        ? 1
        : -1;
    });

    let yearFilterButtons = [];

    for (let i = 0; i < yearsAggregatedArray.length; i += 1) {
      yearFilterButtons.push(
        <li><p className="link no-margin tab-num"
               onClick={this.addFilter.bind(this)}
               data-filter-title={'year ' + yearsAggregatedArray[i].name}
               data-filter={'year-' + yearsAggregatedArray[i].name}>{yearsAggregatedArray[i].name} ({yearsAggregatedArray[i].amount})</p></li>
      );
    }

    return yearFilterButtons;
  }

  getTagsList() {
    let tagsAggregated = {};
    this.forEachDocument((doc) => {
      let docTags = doc.parentElement.getAttribute('data-tags').split(', ');
      for (var i = 0; i < docTags.length; i++) {
        if (tagsAggregated.hasOwnProperty(docTags[i])) tagsAggregated[docTags[i]] += 1;
        else tagsAggregated[docTags[i]] = 1;
      }
    });

    let tagsAggregatedArray = []
    for (let tag in tagsAggregated) {
      tagsAggregatedArray.push({name: tag, amount: tagsAggregated[tag]});
    }

    tagsAggregatedArray.sort(function(a, b) {
      return a.name.toLowerCase() > b.name.toLowerCase()
        ? 1
        : -1;
    });

    let tagFilterButtons = [];

    for (let i = 0; i < tagsAggregatedArray.length; i += 1) {
      tagFilterButtons.push(
        <li><p className="link no-margin tab-num"
               onClick={this.addFilter.bind(this)}
               data-filter-title={`tag "${tagsAggregatedArray[i].name}"`}
               data-filter={'tag-' + tagsAggregatedArray[i].name.split(' ').join('-')}>{tagsAggregatedArray[i].name} ({tagsAggregatedArray[i].amount})</p></li>
      );
    }

    return tagFilterButtons;
  }

  render() {
    return (
      <div className="menu__library" style={{display: this.props.routerLocation.pathname === '/library' ? 'block': 'none'}}>
        <form onSubmit={this.textSearch.bind(this)}>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: '100%'}}>
            <p style={{paddingRight: '0.42rem', flex: '0 1 30%'}}>Search:</p>
            <input className="p menu__library__search" name="text-search" type="text" style={{flex: '1 0 70%', overflow: 'hidden'}} autoComplete="off"></input>
          </div>
        </form>

        <p className="no-margin">Filter by:</p>
        <p className="link no-margin" onClick={this.optionClicked.bind(this)} data-option="tag">
          <span className="no-interact" style={{display: this.state.selected === 'tag' ? 'none': 'block'}}>tag</span>
          <span className="no-interact" style={{display: this.state.selected === 'tag' ? 'block': 'none'}}>{stringAsCharPattern('tag', '•')}</span>
        </p>
        <p className="link" onClick={this.optionClicked.bind(this)} data-option="year">
          <span className="no-interact" style={{display: this.state.selected === 'year' ? 'none': 'block'}}>year</span>
          <span className="no-interact" style={{display: this.state.selected === 'year' ? 'block': 'none'}}>{stringAsCharPattern('year', '•')}</span>
        </p>

        <ul className="no-bullet tab-num" style={{display: this.state.selected === 'year' ? 'block': 'none'}}>
          {this.getYearsList()}
        </ul>
        <ul className="no-bullet" style={{display: this.state.selected === 'tag' ? 'block': 'none'}}>
          {this.getTagsList()}
        </ul>
      </div>
    )
  }
}

module.exports = MenuLibrary;



// WEBPACK FOOTER //
// ./src/js/menu-library.jsx